import { useContext } from 'react';
import type { SpUserProfileApi } from '@sp-api/user-api';
import ApiContext from '../components/ApiProvider/ApiContext';

export default function useUserApiClient(): SpUserProfileApi {
  const { userApi } = useContext(ApiContext);

  return userApi;
}
